/* eslint-disable no-restricted-imports */
import {
	detailsProductEmptySX,
	disabledTextDetailsSX,
	OrderItemDetailsAttributesFrameSX,
	OrderItemDetailsContentSX,
	OrderItemDetailsFrameSX,
	OrderItemDetailsImageBadgeSX,
	OrderItemDetailsImageFrameSX,
	OrderItemDetailsImageSX,
	OrderItemDetailsMoreThanOneFrameSX,
} from '@/components/content/OrderHistory/parts/History/style/historyOrders';
import { Box, Stack, Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { Img } from '@/components/blocks/MaterialImage';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const OrderItemDetailsEmpty = () => {
	const isMobile = useIsMobile();

	return (
		<Stack
			direction="row"
			sx={length > 1 ? OrderItemDetailsMoreThanOneFrameSX : OrderItemDetailsFrameSX}
		>
			<Stack direction="row" sx={OrderItemDetailsContentSX(isMobile)}>
				<Linkable sx={OrderItemDetailsImageFrameSX(isMobile)}>
					<Stack direction="column">
						<RenderProductImg
							fullImageRaw=""
							render={(src) => (
								<Img
									sx={OrderItemDetailsImageSX(isMobile)}
									src={src}
									alt="Producto no disponible"
								/>
							)}
						/>
						<Box sx={OrderItemDetailsImageBadgeSX(isMobile)}>{'1'}</Box>
					</Stack>
				</Linkable>
				<Stack direction="column" sx={OrderItemDetailsAttributesFrameSX(isMobile)}>
					<Linkable>
						<Typography component={'h2'} sx={detailsProductEmptySX}>
							{'Producto no disponible'}
						</Typography>
					</Linkable>
					<Typography component={'h3'} sx={disabledTextDetailsSX}>
						{'Información no disponible'}
					</Typography>
				</Stack>
			</Stack>
		</Stack>
	);
};
